/*
 * Copyright (c) 2020.
 * Simon
 */

import {
    DOMAIN_CREATE_SUCCESS,
    DOMAIN_DETAIL_SUCCESS,
    DOMAIN_EDIT_SUCCESS,
    MY_COMPANIES_DOMAIN_LIST_SUCCESS,
    MY_DOMAIN_LIST_SUCCESS
} from "../../types";

/**
 * @param {*} state
 * @param {*} action
 */
const DomainsReducer = (state = {}, action) => {
    if (action.payload === undefined || action.payload === false) return state;

    switch (action.type) {
        case MY_COMPANIES_DOMAIN_LIST_SUCCESS:
        case MY_DOMAIN_LIST_SUCCESS:
            let domains = action.payload.data.data;

            domains.map((domain) => {
                let id = domain['id'];
                domain.approve_telegram_group = domain.telegram_group.name
                state[id] = domain;
                return true;
            });

            return {...state, action};

        case DOMAIN_EDIT_SUCCESS:
        case DOMAIN_DETAIL_SUCCESS:
        case DOMAIN_CREATE_SUCCESS:
            let id = action.payload.data['id'];
            state[id] = action.payload.data;
            return {...state, action};
        default:
            return state;
    }
};

export {DomainsReducer}